/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mergeClasses } from "../../packages/fluent9";

import { useStyles } from "./FlexItem.styles";
import { FlexItemProps } from "./FlexItemProps";

/**
 * The React hook to get the CSS class name for the FlexItem component.
 * @param props The properties.
 * @returns The class name.
 */
export const useClassName = (props: FlexItemProps): string => {
    const { className } = props;
    const styles = useStyles();

    return className ? mergeClasses(styles.root, className) : styles.root;
};
